<template>
  <div>
    <div v-if="data.status == 'Rejected'">
      <v-layout pt-12 wrap justify-center>
        <v-flex xs12 pt-6>
          <span
            style="font-family: poppinsmedium; font-size: 18px; color: #090909"
          >
            Your account is
            {{ data.status }}
          </span>
          <span
            style="font-family: poppinsmedium; font-size: 18px; color: #090909"
            v-if="data.reason"
          >
            Due to {{ data.reason }}
          </span>
         
        </v-flex>
        <v-flex pt-4 xs12>
           <v-img  src="./../../assets/rejected.svg" height="150px" contain />
        </v-flex>
        <v-flex xs12 pt-12>
          <span
            style="font-family: poppinsmedium; font-size: 18px; color: #090909"
          >
            Click to complete Registration
          </span>
        </v-flex>
        <v-flex xs12 md6 lg3 xl2 px-2>
          <v-btn
            block
            tile
            color="#3EA56E"
            dark
            :ripple="false"
            depressed
            to="/sellerRegistration"
          >
            <span
              style="
                font-family: poppinssemibold;
                font-size: 12px;
                text-transform: none;
              "
              >Complete Registration</span
            >
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="data.status == 'Pending'">
      <v-layout pt-12 wrap justify-end fill-height>
        <v-flex xs12 pt-12 align-self-center>
          <v-img src="./../../assets/pending.svg" height="150px" contain />
        </v-flex>
        <v-flex xs12 pt-4>
          <span
            style="font-family: poppinsregular; font-size: 18px; color: #090909"
          >
            Your Account is under processing for Admin Approval...<br />
            Please wait for a while and Relogin
          </span>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["status"],
  data() {
    return {
      data: [],
    };
  },
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
  },
  mounted() {
    this.checkStatus();
  },
  methods: {
    checkStatus() {
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.data = response.data.data;
            this.$store.commit("userData", response.data.data);
            if (response.data.data.status == "Active") {
              this.$router.push("/Seller");
            }
            // if (response.data.data.status == "Pending") {
            //   var check=window.location.href = "/sellerStatus/Pending"
            //   if (!check) {
            //     this.$router.push({
            //       name: "sellerStatus",
            //       params: { status: "Pending" },
            //     });
            //   } else {
            //     return;
            //   }
            // }
            // if (response.data.data.status == "Rejected") {
            //   var check1=window.location.href == "/sellerStatus/Rejected"
            //   if (!check1) {
            //     this.$router.push({
            //       name: "sellerStatus",
            //       params: { status: "Rejected" },
            //     });
            //   } else {
            //     return;
            //   }
            // }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>